import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Fetches the list of API keys (accounts) for the current user.
 * Returns an array of objects with at minimum { id, name }.
 * Uses the /summary/ endpoint per Task 1 URL fix.
 */
export function useApiKeyList() {
    const [keys, setKeys] = useState([]);
    useEffect(() => {
        let alive = true;
        axios.get('/api/v1/accounts/summary/')
            .then((r) => { if (alive) setKeys(r.data); })
            .catch(() => {});
        return () => { alive = false; };
    }, []);
    return keys;
}
